import angular from "angular";
import HttpFactory from "./http.factory";
import AuthFactory from "./auth.factory";
import MatchesFactory from "./matches.factory";
import ReportsFactory from "./reports.factory";
import PaymentsFactory from "./payments.factory";
import TeamsFactory from "./teams.factory";
import JudgesFactory from "./judges.factory";
import CoachesFactory from "./coaches.factory";
import StaffFactory from "./staff.factory";
import TrainersFactory from "./trainers.factory";
import LeaguesFactory from "./leagues.factory";
import PlayersFactory from "./players.factory";
import MiscFactory from "./misc.factory";
import FileReader from "./fileReader.service";
import TransfersFactory from "./transfers.factory";
import RolesFactory from "./roles.factory";
import User from "./user.factory";
import UsersFactory from "./users.factory";
import TrainingEntriesFactory from "./trainingEntries.factory";
import TrainingCentersFactory from "./trainingCenters.factory";

let servicesModule = angular.module("app.services", [
  HttpFactory,
  AuthFactory,
  MatchesFactory,
  ReportsFactory,
  PaymentsFactory,
  TeamsFactory,
  JudgesFactory,
  CoachesFactory,
  TrainersFactory,
  LeaguesFactory,
  PlayersFactory,
  MiscFactory,
  FileReader,
  TransfersFactory,
  User,
  RolesFactory,
  UsersFactory,
  TrainingEntriesFactory,
  StaffFactory,
  TrainingCentersFactory,
]).name;

export default servicesModule;



// WEBPACK FOOTER //
// ./client/app/services/services.js